<a
    href="https://wa.me/919575502277"
    class="floating-whatsapp"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with us on WhatsApp">

    <i class="fab fa-whatsapp"></i>

</a>